export default __webpack_public_path__ + "static/media/Normal.0e6b8d6f.svg";